import PlaySolid from './Solid/Play'
import ImageSolid from './Solid/Image'
import GripVerticalSolid from './Solid/GripVertical'
import ChartLineUpSolid from './Solid/ChartLineUp'
import ChartLineDownSolid from './Solid/ChartLineDown'

import PlayRegular from './Regular/Play'
import CheckRegular from './Regular/Check'
import ExclamationTriangleRegular from './Regular/ExclamationTriangle'
import CircleCheckRegular from './Regular/CircleCheck'
import EyeRegular from './Regular/Eye'
import LowVisionRegular from './Regular/LowVision'
import PaletteRegular from './Regular/Palette'
import StarRegular from './Regular/Star'

import CopyLight from './Light/Copy'
import GlobeLight from './Light/Globe'
import ImagePolaroidLight from './Light/ImagePolaroid'
import PencilRulerLight from './Light/PencilRuler'
import TrashAltLight from './Light/TrashAlt'
import AddCircleLight from './Light/AddCircle'
import ClipboardLight from './Light/Clipboard'

import FacebookBrand from './Brands/Facebook'
import LinkedInBrand from './Brands/LinkedIn'
import InstagramBrand from './Brands/Instagram'
import SquareFacebookBrand from './Brands/SquareFacebook'
import SquareLinkedInBrand from './Brands/SquareLinkedIn'
import SquareYouTubeBrand from './Brands/SquareYouTube'
import SquareXTwitterBrand from './Brands/SquareXTwitter'
import XTwitterBrand from './Brands/XTwitter'

export const ICON_MAP = {
	'fa-play': PlaySolid,
	'fa-image': ImageSolid,
	'fa-grip-vertical': GripVerticalSolid,
	'fa-arrow-up': ChartLineUpSolid,
	'fa-arrow-down': ChartLineDownSolid,
	'fa-play-regular': PlayRegular,
	'fa-check': CheckRegular,
	'fa-circle-check': CircleCheckRegular,
	'fa-exclamation-triangle': ExclamationTriangleRegular,
	'fa-eye': EyeRegular,
	'fa-low-vision': LowVisionRegular,
	'fa-palette': PaletteRegular,
	'fa-star': StarRegular,
	'fa-copy': CopyLight,
	'fa-globe': GlobeLight,
	'fa-image-polaroid': ImagePolaroidLight,
	'fa-pencil-ruler': PencilRulerLight,
	'fa-trash-alt': TrashAltLight,
	'fa-plus-circle': AddCircleLight,
	'fa-clipboard': ClipboardLight,
	'fa-facebook': FacebookBrand,
	'fa-linkedin': LinkedInBrand,
	'fa-instagram': InstagramBrand,
	'fa-square-facebook': SquareFacebookBrand,
	'fa-square-linkedin': SquareLinkedInBrand,
	'fa-square-youtube': SquareYouTubeBrand,
	'fa-square-x-twitter': SquareXTwitterBrand,
	'fa-x-twitter': XTwitterBrand,
}

export const ICON_UNICODE_MAP = {
	'fa-check': '\\e001',
	'fa-circle-check': '\\e008',
	'fa-exclamation-triangle': '\\e029',
	'fa-eye': '\\e00a',
	'fa-play': '\\e01f',
	'fa-image': '\\e017',
	'fa-palette': '\\e01b',
	'fa-star': '\\e025',
	'fa-globe': '\\e00c',
	'fa-plus-circle': '\\e000',
	'fa-arrow-up': '\\e004',
	'fa-arrow-down': '\\e003',
	'fa-facebook': '\\e00d',
	'fa-linkedin': '\\e019',
	'fa-instagram': '\\e018',
	'fa-copy': '\\e00e',
	'fa-clipboard': '\\e00b',
	'fa-image-polaroid': '\\e016',
	'fa-pencil-ruler': '\\e01d',
	'fa-trash-alt': '\\e027',
	'fa-low-vision': '\\e013',
	'fa-square-facebook': '\\e020',
	'fa-square-linkedin': '\\e022',
	'fa-square-youtube': '\\e024',
	'fa-square-x-twitter': '\\e021',
	'fa-x-twitter': '\\e02a',
}
